@if (feldBeschreibung | async; as item) {
  @if (item?.hilfetext) {
    <mat-icon
      svgIcon="innogy_picto_speech-bubble_exclamationmark"
      [attr.aria-hidden]="disabled"
      [attr.aria-label]="item?.hilfetext"
      [matTooltip]="disabled ? '' : item?.hilfetext"
      [class.disabled]="disabled"
      matTooltipClass="multiline-tooltip"
      [matTooltipPosition]="tooltipPosition"
    >
    </mat-icon>
  }
}
